import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PCCService {
  private pccServiceAPI = environment.apiV2URL + '/pcc-services';

  private http: HttpClient = inject(HttpClient);

  public constructor() {}

  public clearCache(cacheNames: string[], params?: HttpParams): Observable<void> {
    return this.http.post<void>(`${this.pccServiceAPI}/clear-cache`, cacheNames, { params });
  }
}
